module.exports = __webpack_public_path__ + "img/logo-ybk.a5398831.png";